export const HlzSlideArray = [
  {
    id: 1,
    image: require('../images/Home/hlz-BuildingA.jpg'),
    // image: require('../images/Home/hlz-building-工厂全景.jpg'),
    alt: 'images/home/.jpg',
    name: 'HLZ Company Building',
    title: 'HLZ Company Building',
    text: 'HLZ Company Building: 广东省东莞市大岭山镇大片美路73号2号楼801室',
    description: '合利资科技 广东东莞市大岭',
  },
  {
    id: 2,
    image: require('../images/Home/hlz-Lobby.jpg'),
    // image: require('../images/Home/hlz-lobby-前台.jpg'),
    alt: 'images/home/hlz-Lobby.jpg',
    name: 'Office Lobbby',
    title: 'Office Lobbby',
    text: 'HLZ Office Lobby: 广东省东莞市大岭山镇大片美路73号2号8楼',
    description: '合利资科技接待大厅',
  },
  {
    id: 3,
    image: require('../images/Home/hlz-OfficeArea.jpg'),
    // image: require('../images/Home/hlz-office-大办公区.jpg'),
    alt: 'images/home/hlz-OfficeArea.jpg',
    name: 'Engineering Department Office',
    title: 'Engineering Department Office',
    text: 'HLZ Office Area: 广东省东莞市大岭山镇大片美路73号2号8楼',
    description: '合利资科技联合办公区域',
  },
  {
    id: 3,
    image: require('../images/Home/hlz-MeetingRoom.jpg'),
    // image: require('../images/Home/hlz-meeting-会议室.jpg'),
    alt: 'images/home/hlz-MeetingRoom.jpg',
    name: 'Metting Room',
    title: 'Meeting Room',
    text: 'HLZ Meeting Room: 广东省东莞市大岭山镇大片美路73号2号8楼',
    description: '合利资科技大会议室',
    // link: 'https://www.twitter.com'
  }
]